import { IDangNhapBody, IDangNhapRes } from 'src/types/auth.type';
import http from 'src/utils/http';

export default class AuthService {
  private url = '/auth';

  public async login(body: IDangNhapBody) {
    const { data } = await http.post<IDangNhapRes>(`${this.url}/login`, body);
    return data;
  }

  public async logout() {
    const { data } = await http.get<boolean>(`${this.url}/logout`);
    return data;
  }

  public async refresh() {
    const { data } = await http.post<IDangNhapRes>(`${this.url}/refresh`);
    return data;
  }
}
